<template>
  <div class="box" v-loading="loading">
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>
    <!-- <div class="card_wrap">
      <div class="card">
        <div class="input">
          <input-card
            :title="language('SettlementReport.transaction')"
            :dataArr="inputArr"
            labelPosition="top"
            @change="changeInput"
          ></input-card>
        </div>
      </div>
      <div class="tips">{{ language("SettlementReport.searchTips") }}</div>
      <div class="button_wrap">
        <el-button type="primary">{{
          language("SettlementReport.search")
        }}</el-button>
      </div>
    </div> -->

    <div class="table_wrap">
      <div class="sis">
        <div class="sis_data">
          <div class="name"><h3>Master A/C</h3></div>
          <div>
            <h3>{{ shopData.merchantNum }}</h3>
          </div>
        </div>
        <div class="sis_data">
          <div class="name"><h3>Merhant ID</h3></div>
          <div>
            <h3>{{ shopData.shopNum }}</h3>
          </div>
        </div>
        <div class="sis_data">
          <div class="name"><h3>Shop Name</h3></div>
          <div>
            <h3>{{ shopData.nameChi }}</h3>
          </div>
        </div>
      </div>
      <div class="count_box">
        <div class="count">
          {{ language("orderRecord.results") }}: {{ results }}
          {{ language("orderRecord.rows") }}
        </div>
        <div class="page_wrap">
          <page :total="results" @pageChange="pageChange" ref="page"></page>
        </div>
      </div>
      <cc-table
        :loadData="false"
        :config="table"
        :params="params"
        :dataArr="dataArr"
        :refeshParams="refeshTable"
        :emptyText="language('SettlementReport.emptyText')"
        :showIndex="false"
        :buttonsWidth="115"
      ></cc-table>
    </div>
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import inputCard from "../../components/inputCard";
import page from "../../components/page";

export default {
  components: {
    breadcrumb,
    inputCard,
    page,
  },
  data() {
    return {
      loading: false,
      breadcrumb: {
        title: this.language("SettlementReport.breadcrumbTitle"),
        list: [
          {
            name: this.language("SettlementReport.breadcrumbList_1"),
          },
          {
            name: this.language("SettlementReport.breadcrumbList_2"),
          },
        ],
      },
      inputArr: [
        {
          name: "Merhant ID",
          apiName: "MerhantIDID",
          value: "",
          type: "select",
          options: [],
        },
      ],
      params: {},
      refeshTable: -1,
      table: {
        api: "",
        showPager: false,
        columns: [
          {
            prop: "period",
            lable: "Period",
          },
          {
            prop: "mchNum",
            lable: "Master A/C",
          },
          {
            prop: "mchShopNum",
            lable: "Merhant ID",
          },
        ],
        buttons: [
          {
            name: this.language("SettlementReport.download"),
            click: (row, index) => {
              window.open(
                process.env.VUE_APP_download +
                  "admin/merchant/report/saleSummary/download?dataType=0&id=" +
                  row.id
              );
            },
          },
        ],
      },
      dataArr: [],
      results: 0,
      form: {
        pageSize: 10,
        pageNo: 1,
      },
      shopData: {},
    };
  },
  methods: {
    changeInput(e) {
      console.log(e);
    },
    pageChange(e) {
      this.form.pageSize = e.pageSize;
      this.form.pageNo = e.pageNo;
      this.getData(this.form);
    },
    getData(e) {
      this.loading = true;
      e.shopNum = this.shopData.shopNum;
      e.mchShopNum = this.shopData.shopNum;
      this.ccRequest
        .do("admin/merchant/report/saleSummary?dataType=1", e)
        .then((res) => {
          this.dataArr = res.rows;
          this.results = res.total;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
    },
  },
  mounted() {
    let shopData = this.$shopData;
    this.shopData = shopData;
    this.getData({
      pageSize: 10,
      pageNo: 1,
    });
  },
};
</script>
<style scoped lang="scss">
.box {
  height: 100%;
}
.card_wrap {
  background: #f7f7f7;
  padding: 20px;
  h5 {
    font-size: $title;
    margin: 10px 0 20px 0;
  }
  .card {
    display: flex;
    flex-wrap: wrap;

    .input {
      flex: 1;
      width: 300px;
    }
  }
}
.tips {
  margin-top: 10px;
  font-size: $sbuTitle;
}
.button_wrap {
  margin-top: 20px;
}

.button_wrap {
  margin-bottom: 20px;
}
.sis {
  margin: 40px 0;
}
.sis_data {
  margin: 10px 0;
  display: flex;
  .name {
    width: 150px;
  }
}
.table_wrap {
  margin-top: 50px;
  .count {
    font-size: $sbuTitle;
    font-weight: 600;
  }
  .count_box {
    margin-bottom: 20px;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>